// @ts-nocheck

import * as R from 'ramda';
import {
  DELETE_WHITELISTED_DEVICES,
  GET_WHITELISTED_DEVICES,
  SAVE_WHITELISTED_DEVICES,
  UPDATE_WHITELISTED_DEVICES,
} from '../actions/WhitelistedDeviceActions';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';
import type { WhitelistDevice, WhitelistedDevicesOrmReducer } from '../types/whitelistedDevicesOrmTypes';
import '../types/whitelistedDevicesOrmTypes';
export function createInitialState(): WhitelistedDevicesOrmReducer {
  return {
    loadingStatus: LOADING_STATUS.init,
    error: null,
    data: [],
  };
}
const INIT_STATE = createInitialState();

function isDeviceEqual(device1: WhitelistDevice, device2: WhitelistDevice) {
  return device1.app_id === device2.app_id && device1.device_id === device2.device_id;
}

function Handler(state: WhitelistedDevicesOrmReducer = INIT_STATE, action) {
  switch (action.type) {
    case GET_WHITELISTED_DEVICES.response:
      return { ...state, loadingStatus: LOADING_STATUS.LOADED, data: R.path(['devices'], action.data) };

    case UPDATE_WHITELISTED_DEVICES.response:
    case SAVE_WHITELISTED_DEVICES.response:
      const saved = R.path(['device'], action.data);
      const stateData = state.data || [];

      if (saved) {
        const hasDevice = stateData.some((device) => isDeviceEqual(device, saved));
        const data = hasDevice
          ? stateData.map((device) => {
              if (isDeviceEqual(saved, device)) {
                return saved;
              }

              return device;
            })
          : stateData.concat(saved);
        return { ...state, loadingStatus: LOADING_STATUS.LOADED, data: data };
      }

    case DELETE_WHITELISTED_DEVICES.response:
      const deleted = R.path(['device_id'], action.data);
      const stateDataDelete = state.data || [];
      const hasDeviceDelete = stateDataDelete.some((device) => device.device_id === deleted);

      if (!hasDeviceDelete) {
        return { ...state, loadingStatus: LOADING_STATUS.LOADED };
      }

      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        data: stateDataDelete.filter((device) => device.device_id !== deleted),
      };

    default:
      return state;
  }
}

const WhitelistDevicesOrm = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_WHITELISTED_DEVICES, SAVE_WHITELISTED_DEVICES, UPDATE_WHITELISTED_DEVICES, DELETE_WHITELISTED_DEVICES],
  error: [GET_WHITELISTED_DEVICES, SAVE_WHITELISTED_DEVICES, UPDATE_WHITELISTED_DEVICES, DELETE_WHITELISTED_DEVICES],
});
export default WhitelistDevicesOrm;
